import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@app/core/helperclasses/basecomponent';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface BreadcrumbItem {
  title: string;
  url_tree: string;
  isIcon?: boolean;
  isActiveChapter?: boolean;
}

@UntilDestroy()
@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.style.scss'],
  host: {
    class: 'breadcrumb-sc',
  },
})
export class BreadcrumbComponent
  extends BaseComponent
  implements AfterViewInit
{
  @Input() showTitle: boolean = false;
  @Input() title: string = '';
  @Input() data!: BreadcrumbItem[];
  @ViewChild('breadcrumbList') breadcrumbList!: ElementRef;
  isOverflowing: boolean = false;
  isAtStart: boolean = true;
  isAtEnd: boolean = false;

  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngAfterViewInit() {
    this.checkOverflow();
    this.updateButtonState();
    window.addEventListener('resize', () => {
      this.checkOverflow();
      this.updateButtonState();
    });
    this.breadcrumbList.nativeElement.addEventListener('scroll', () =>
      this.updateButtonState(),
    );
  }

  checkOverflow() {
    const el = this.breadcrumbList.nativeElement;
    this.isOverflowing = el.scrollWidth > el.clientWidth;
    if (this.isOverflowing) {
      this.renderer.addClass(el, 'has-overflow');
    } else {
      this.renderer.removeClass(el, 'has-overflow');
    }
  }

  updateButtonState() {
    const el = this.breadcrumbList.nativeElement;
    this.isAtStart = el.scrollLeft === 0;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.isAtEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth;
    });
  }

  scrollLeft() {
    const el = this.breadcrumbList.nativeElement;
    el.scrollBy({ left: -150, behavior: 'smooth' });
  }

  scrollRight() {
    const el = this.breadcrumbList.nativeElement;
    el.scrollBy({ left: 150, behavior: 'smooth' });
  }
}
